import { render, staticRenderFns } from "./invest-project-trend.vue?vue&type=template&id=4dedf62d&"
import script from "./invest-project-trend.vue?vue&type=script&lang=js&"
export * from "./invest-project-trend.vue?vue&type=script&lang=js&"
import style0 from "./invest-project-trend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports